export default "__VITE_ASSET__aNFKk6ry__"